export default "__VITE_ASSET__DKzdOzkv__"